import {
  Flex,
  Text
} from '@chakra-ui/react';
import Link from 'next/link';
import { SubmitButton } from '@/components/Button/SubmitButton/SubmitButton';
import { TextLink } from '@/components/Link/TextLink/TextLink';
import { getPageInfo } from '@/config/pages';

export type PcShopDetailBookingLinkProps = {
  slug: string;
  name: string;
  shopTel?: string | null;
  width?: string;
  isBookable: boolean;
}

export const PcShopDetailBookingLink = ({
  slug,
  name,
  shopTel,
  width = '30%',
  isBookable,
}: PcShopDetailBookingLinkProps) => {
  if (!isBookable) return null;
  return (
    <Flex
      justifyContent={'center'}
      flexDirection={'column'}
      mx={'auto'}
      py={6}
    >
      <Link
        href={getPageInfo('studio/{slug}/booking', { slug: slug, name: name }).href}
        style={{ textAlign: 'center'}}
      >
        <SubmitButton
          w={width}
          size={'lg'}
          color={'white'}
          bg={'brand.500'}
          mb={3}
        >
          WEB予約する
        </SubmitButton>
      </Link>
      {shopTel &&
        <TextLink
          textAlign={'center'}
          bg={'white'}
          as={'a'}
          href={`tel:${shopTel}`}
          rel={'noreferrer'}
        >
          <Text>電話予約する {shopTel}</Text>
        </TextLink>
      }
    </Flex>
  );
};
